import { transport } from 'config/transport';

export function callApiDeleteKhanDong(congDoanId, nunId, id) {
    return transport.del(`/congdoan/${congDoanId}/khandong/${nunId}/${id}`);
}
